import { useRef, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import JoditEditor from "jodit-react";

const News = [
  {
    id: "1",
    category: "tax",
    name: "TAX",
  },
  {
    id: "2",
    category: "labor",
    name: "Labor",
  },
  {
    id: "3",
    category: "general",
    name: "General",
  },
  {
    id: "4",
    category: "FDI",
    name: "FDI",
  },
];
const AddNews = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [content, setContent] = useState(""); // Rich text content
  const [singleImage, setSingleImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const editor = useRef(null);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("category", category);
    formData.append("content", content);

    if (singleImage) {
      formData.append("singleImage", singleImage);
    }

    try {
      const response = await axios.post(
        "https://mirai-server.vercel.app/upload-news",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success("Column uploaded successfully!");
      console.log(response.data);
    } catch (error) {
      toast.error("Failed to upload news.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <h1 className="w-full bg-white px-6 py-8 shadow-lg text-4xl font-mono">
        Add Column
      </h1>
      <form
        onSubmit={handleSubmit}
        encType="multipart/form-data "
        className="p-5 m-6 bg-white shadow-lg"
      >
        <div className="flex flex-col gap-5 w-full">
          <div className="mb-4 flex flex-col gap-2">
            <label className="text-xl font-mono text gray-900">Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="text-xl font-mono text gray-900 border border-gray-900 w-[60%]"
              required
            />
          </div>
          <div className="mb-4 flex flex-col gap-2">
            <label className="text-xl font-mono text gray-900">
              Category
            </label>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
             className="text-xl font-mono text gray-900 border border-gray-900 w-[60%]"
              required
            >
              <option value="" disabled>
                Select a category
              </option>
              {News.map((item) => (
                <option key={item.id} value={item.category}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full">
            <div className="flex flex-col gap-2">
              <label className="text-xl font-mono text gray-900">
                Single Image
              </label>
              <input
                type="file"
                onChange={(e) => setSingleImage(e.target.files[0])}
                accept="image/*"
              />
            </div>
          </div>
          <div className="flex flex-col gap-3 mt-5">
            <label className="text-xl font-mono text gray-900">
              Column Details:
            </label>
            <JoditEditor
              ref={editor}
              value={content}
              onBlur={(newContent) => setContent(newContent)} // Update state on editor blur
              onChange={(newContent) => setContent(newContent)} // Fallback for real-time changes
            />
          </div>
        </div>
        <button
          type="submit"
          className={`bg-gray-900 px-4 py-4 text-white text-xl font-mono mt-10 ${
            loading ? "bg-gray-500" : "bg-gray-900"
          }`}
          disabled={loading}
        >
          {loading ? "Uploading..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default AddNews;
